import { values } from 'lodash';

import { DBDocSchema } from '../../../legacy/objects/generic/db-doc/db-doc-schema';
import { SchemaField } from '../../../legacy/objects/generic/serialization/schema-field';
import { DomMutationSelection } from '../dom-mutation-selection/dom-mutation-selection';
import { ExperienceTrigger } from '../experience-trigger/experience-trigger';

import { DomExperienceType } from './dom-experience-type';
import { SearchExperienceConfig } from './experiments/search-experience-config/search-experience-config';

export class DomExperienceSchema extends DBDocSchema {
  public static readonly displayName = 'displayName';
  public static readonly description = 'description';
  public static readonly type = 'type';
  public static readonly trigger = 'trigger';
  public static readonly mutations = 'mutations';
  public static readonly searchExperienceConfig = 'searchExperienceConfig';
  public static readonly enabled = 'enabled';
  public static readonly canApply = 'canApply';

  public getCollection(orgId: string) {
    return `${super.orgDoc(orgId)}/domExperience`;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition() {
    const parameters = {
      ...super.getSchemaDefinition(),
    };

    parameters[DomExperienceSchema.displayName] = SchemaField.string(undefined).optional();
    parameters[DomExperienceSchema.description] = SchemaField.string(undefined).optional();
    parameters[DomExperienceSchema.type] = SchemaField.string(undefined)
      .required()
      .valid(...values(DomExperienceType));
    parameters[DomExperienceSchema.trigger] = SchemaField.obj(ExperienceTrigger, undefined).required();
    parameters[DomExperienceSchema.mutations] = SchemaField.arrayOfType(
      SchemaField.obj(DomMutationSelection, undefined),
      undefined,
    ).required();
    parameters[DomExperienceSchema.searchExperienceConfig] = SchemaField.obj(
      SearchExperienceConfig,
      undefined,
    ).optional();
    parameters[DomExperienceSchema.enabled] = SchemaField.boolean(undefined).optional();
    parameters[DomExperienceSchema.canApply] = SchemaField.boolean(undefined).optional();
    return parameters;
  }
}
